export const defaultState = {
    test: "",
    loginDetails: {},
    profileDetails: {},
    profileDetailsLoading: false,
    clientID: {},
    creatorDetails: {},
    isViewAboutUs: false,
    handleProfileDetails: false,
    isFirstTime: false,
    consumerDetails: {},
    isNewComer: false,
    personalDetail: {},
    linkedPersonalDetails:{}
}